import { Box, Icon, Theme, Typography } from "@outschool/backpack";
import { faEye, faEyeSlash } from "@outschool/icons";
import { Trans, useTranslation } from "@outschool/localization";
import React from "react";

import Link from "../Link";

export function PrivacyDisclaimerText({
  privacyState,
  privateLink,
}: {
  privacyState?: string | null;
  privateLink: string;
}) {
  const { t } = useTranslation("client\\routes\\ParentProfile");

  if (privacyState === "private link") {
    return (
      <>
        <Icon
          icon={faEye}
          sx={(theme: Theme) => ({
            color: theme.palette.neutral[600],
            marginRight: 3,
          })}
        />
        <Typography
          sx={(theme: Theme) => ({ color: theme.palette.neutral[600] })}
          variant="body2"
        >
          <Trans t={t}>
            Visible to anyone with my{" "}
            <Link to={privateLink} target="_blank">
              private profile link
            </Link>
          </Trans>
        </Typography>
      </>
    );
  }

  if (privacyState === "anyone") {
    return (
      <>
        <Icon
          icon={faEye}
          sx={(theme: Theme) => ({
            color: theme.palette.neutral[600],
            marginRight: 3,
          })}
        />
        <Typography
          sx={(theme: Theme) => ({ color: theme.palette.neutral[600] })}
          variant="body2"
        >
          {t("Visible to anyone visiting Outschool")}
        </Typography>
      </>
    );
  }

  if (privacyState === "only me") {
    return (
      <>
        <Icon
          icon={faEyeSlash}
          sx={(theme: Theme) => ({
            color: theme.palette.neutral[600],
            marginRight: 3,
          })}
        />
        <Typography
          sx={(theme: Theme) => ({ color: theme.palette.neutral[600] })}
          variant="body2"
        >
          {t("Only visible to me")}
        </Typography>
      </>
    );
  }

  return null;
}

export function AlwaysVisibleDisclaimerText() {
  const { t } = useTranslation("client\\routes\\ParentProfile");

  return (
    <Box>
      <Icon
        icon={faEye}
        sx={(theme: Theme) => ({
          color: theme.palette.neutral[600],
          marginRight: 3,
        })}
      />
      <Typography
        variant="body2"
        sx={(theme: Theme) => ({ color: theme.palette.neutral[600] })}
      >
        {t(
          "Publicly submitted reviews are always visible to anyone visiting Outschool",
        )}
      </Typography>
    </Box>
  );
}

export function AlwaysVisiblePhotosDisclaimerText() {
  const { t } = useTranslation("client\\routes\\ParentProfile");

  return (
    <Box>
      <Icon
        icon={faEye}
        sx={(theme: Theme) => ({
          color: theme.palette.neutral[600],
          marginRight: 3,
        })}
      />
      <Typography
        variant="body2"
        sx={(theme: Theme) => ({ color: theme.palette.neutral[600] })}
      >
        {t(
          "Publicly submitted review photos are always visible to anyone visiting Outschool",
        )}
      </Typography>
    </Box>
  );
}
